import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

const ENDPOINT = `${config.api.url}/organization/appointment-type-preset-visibility`;

const appointmentTypePresetVisibilityApi = {
  get: async () => {
    const response = await fetch(ENDPOINT, {
      headers: getAuthHeaders(),
    });
    if (response.status === 404) {
      return { hiddenPresetKeys: [] };
    }
    return handleResponse(response);
  },

  update: async (hiddenPresetKeys) => {
    const response = await fetch(ENDPOINT, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ hiddenPresetKeys }),
    });
    return handleResponse(response);
  },
};

export default appointmentTypePresetVisibilityApi;
